import React from "react";
import {
  Pane,
  Strong,
  MenuIcon,
  NotificationsIcon,
  RefreshIcon,
  CameraIcon,
} from "evergreen-ui";

import { getCookie, getDateObject } from "../util";
import { DatePicker } from "antd";
import "antd/dist/antd.css";
import { withRouter } from "react-router-dom";
import { useEffect } from "react";
import OneSignal from "react-onesignal";

const Header = (props) => {
  const { showMenuDrawer, date, dateChange, updateAvailability } = props;
  console.log(date);

  return (
    <div className={"header-container"}>
      <Pane
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
        height={70}
        borderBottom={"1px solid rgb(228,231,235, 0.15)"}
        paddingLeft={10}
        paddingRight={10}
      >
        <Pane
          display={"flex"}
          flexDirection={"Column"}
          height={70}
          paddingTop={10}
          paddingBottom={10}
          justifyContent={"space-between"}
        >
          <Strong color={"white"}>
            {getCookie("clubName")?.length > 18
              ? getCookie("clubName")?.substring(0, 18)?.concat("...")
              : getCookie("clubName")}

            {/* {getCookie('clubName')} */}
          </Strong>
          <div className={"header-action-container"}>
            <DatePicker
              className={"activity-date-picker"}
              defaultValue={getDateObject(date, "ddd, Do MMM YY")}
              value={getDateObject(date, "ddd, Do MMM YY")}
              format={"ddd, Do MMM YY"}
              onChange={(e) => {
                document.querySelector(".activity-date-picker input").blur();
                dateChange(e.format("ddd, Do MMM YY"));
              }}
              inputReadOnly="false"
            />
          </div>
        </Pane>
        <Pane display={"flex"} alignItems={"center"}>
          <Pane marginRight={16}>
            <img
              src="https://playo-website.gumlet.io/QR-icon.png"
              height={"28px"}
              width={"28px"}
              onClick={() => props.history.push("/scan-qr")}
            />
          </Pane>
          <RefreshIcon
            color="white"
            marginRight={20}
            onClick={() => updateAvailability()}
          />
          <NotificationsIcon
            color="white"
            marginRight={20}
            onClick={() => props.history.push("/notifications")}
          />
          <MenuIcon
            color="white"
            marginLeft={0}
            onClick={() => showMenuDrawer(true)}
          />
        </Pane>
      </Pane>
    </div>
  );
};

export default withRouter(Header);
